export enum SmsDirection {
  Unknown = 0,
  Outbound = 1,
  Inbound = 2,
}
